/* ============================================================
   cs-header.js   -   section: cs-header
   Mobile menu open/close with focus handling, and a shadow under the
   header once the page has scrolled.
   ============================================================ */
(function () {
  function init(root) {
    if (root.dataset.csReady) return;
    root.dataset.csReady = '1';

    var menu = root.querySelector('[data-cs-menu]');
    var panel = menu && menu.querySelector('.cs-menu__panel');
    var openBtn = root.querySelector('[data-cs-menu-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      menu.hidden = false;
      void menu.offsetWidth; /* commit the unhidden state so the slide-in still animates */
      menu.classList.add('is-open');
      panel.focus({ preventScroll: true });
      document.documentElement.classList.add('cs-menu-lock');
      openBtn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.classList.remove('is-open');
      document.documentElement.classList.remove('cs-menu-lock');
      openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!menu.classList.contains('is-open')) menu.hidden = true; }, 380);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (menu && openBtn) {
      openBtn.addEventListener('click', open);
      menu.addEventListener('click', function (e) {
        if (e.target.closest('[data-cs-menu-close]')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
      });
      /* the drawer is fine at desktop width, so close it if the window grows */
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches && !menu.hidden) close(); });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        root.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    }, { passive: true });
  }

  function boot() { document.querySelectorAll('[data-cs-header]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
